/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ number: NonNullable<unknown> }} Publish_VersionInputs */

const zh_publish_version = /** @type {(inputs: Publish_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`版本 ${i?.number}`)
};

const en_publish_version = /** @type {(inputs: Publish_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Version ${i?.number}`)
};

const es_publish_version = /** @type {(inputs: Publish_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Versión ${i?.number}`)
};

/**
* | output |
* | --- |
* | "Version {number}" |
*
* @param {Publish_VersionInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const publish_version = /** @type {((inputs: Publish_VersionInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publish_VersionInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_publish_version(inputs)
	if (locale === "en") return en_publish_version(inputs)
	return es_publish_version(inputs)
});